const state = {};

// company.employee.EmployeeDetails.list
export default {
  state,
};
